import { useContext, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import log from "logbeacon";
import { QUERY_KEYS } from "../config";
import { useCheckAccessClick } from "./useCheckAccessClick";
import { useCreateChat } from "./useCreateChat";
import { formatMarkdownSpaces, formatMsgQuotes } from "@utils";
import { OspApiClientContext } from "@features";

export const useShareMessage = ({
  id,
  enabled = true,
  agentId,
}: {
  id: string;
  enabled?: boolean;
  agentId?: string;
}) => {
  const { chatApi } = useContext(OspApiClientContext);
  const queryClient = useQueryClient();

  const { onCreate, loading } = useCreateChat();

  // 将继续聊天逻辑作为 originClick 传递给 useCheckAccessClick
  const { handleAccessClick } = useCheckAccessClick({
    originClick: async () => {
      await onCreate({ agentId, shareId: id });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CHAT_HISTORY] });
    },
  });

  const {
    data: chatDetail,
    error,
    isLoading,
  } = useQuery({
    queryKey: [QUERY_KEYS.SHARE_DETAIL, id],
    enabled: !!chatApi && !!id && enabled,
    queryFn: async () => {
      const res = await chatApi?.share.shareDetail(id).catch((error) => {
        return Promise.reject(error);
      });
      if (res?.error) {
        return Promise.reject(res?.error);
      }
      log.debug("[文案]line92", res?.data?.data?.messages);
      return res?.data.data?.messages || [];
    },
  });

  // 使用 handleAccessClick 包裹继续聊天函数，确保用户有权限
  const ContinueChat = (event: React.MouseEvent) => {
    handleAccessClick(event);
  };

  const formatMessages = useMemo(() => {
    return chatDetail?.map((item: any) => {
      return {
        ...item,
        content: formatMarkdownSpaces(formatMsgQuotes(item?.content || "")),
      };
    });
  }, [chatDetail]);

  return {
    messages: formatMessages,
    ContinueChat,
    createChatLoading: loading,
    error: (error as any)?.error || "",
    isLoading,
  };
};
